import { render, staticRenderFns } from "./RoomType.vue?vue&type=template&id=65e67f84"
import script from "./RoomType.vue?vue&type=script&lang=js"
export * from "./RoomType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports